const survey_en = require('./survey.json')
export default survey_en